import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Close3tx65evcwi73t as Close } from './Frame.web.mjs';
import {
  CloseReason10cphaqpp3ct7 as CloseReason,
  Codes_NORMAL_getInstance21orcjign6rr6 as Codes_NORMAL_getInstance,
  Codes_INTERNAL_ERROR_getInstance23f851rin2m6r as Codes_INTERNAL_ERROR_getInstance,
} from './CloseReason.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_send__qhx0g0($this, frame, $completion) {
  var tmp = $this.g5a().e1b(frame, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function send(frame, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_send__qhx0g0.bind(VOID, this, frame), $completion);
}
var WebSocketSessionClass;
function WebSocketSession() {
  if (WebSocketSessionClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'WebSocketSession', VOID, VOID, [CoroutineScope()], [1, 0]);
    WebSocketSessionClass = $;
  }
  return WebSocketSessionClass;
}
function *_generator_close__nh2uv0(_this__u8e3s4, reason, $completion) {
  try {
    var tmp = _this__u8e3s4.h5a(Close().t5b(reason), $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var tmp_0 = _this__u8e3s4.x4i($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  } catch ($p) {
    if ($p instanceof Error) {
      var _unused_var__etf5q3 = $p;
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function close(_this__u8e3s4, reason, $completion) {
  reason = reason === VOID ? CloseReason().z59(Codes_NORMAL_getInstance(), '') : reason;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_close__nh2uv0.bind(VOID, _this__u8e3s4, reason), $completion);
}
function *_generator_closeExceptionally__hurwhz(_this__u8e3s4, cause, $completion) {
  var tmp;
  if (cause instanceof CancellationException()) {
    tmp = CloseReason().z59(Codes_NORMAL_getInstance(), '');
  } else {
    tmp = CloseReason().z59(Codes_INTERNAL_ERROR_getInstance(), cause.toString());
  }
  var reason = tmp;
  var tmp_0 = close(_this__u8e3s4, reason, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function closeExceptionally(_this__u8e3s4, cause, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_closeExceptionally__hurwhz.bind(VOID, _this__u8e3s4, cause), $completion);
}
//region block: exports
export {
  send as send3oe3simbzresd,
  closeExceptionally as closeExceptionally34577q18g9dav,
  close as close1my1iwn6t9rqe,
  WebSocketSession as WebSocketSessionzi1ianvyj32u,
};
//endregion

//# sourceMappingURL=WebSocketSession.mjs.map
